<template>
  <div class="bg-white rounded-sm px-2 pb-4 border shadow-sm">
    <div class="m-3 text-right">
      <button type="submit" v-on:click="exportHtml"
              class="py-2 px-4 uppercase bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
        Save
      </button>
    </div>
    <EmailEditor :appearance="appearance"
                 :project-id="projectId"
                 :locale="locale"
                 :tools="tools"
                 :options="options" ref="emailEditor" v-on:load="editorLoaded"/>

  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";
import {EmailEditor} from 'vue-email-editor'


export default {
  name: "ComposeMail",
  components: {EmailEditor},
  data() {
    return {
      minHeight: "1000px",
      locale: "en",
      projectId: 0, // replace with your project id
      tools: {
        // disable image tool
        image: {
          enabled: true
        }
      },
      options: {},
      appearance: {
        theme: 'dark',
        panels: {
          tools: {
            dock: 'right'
          }
        }
      },
      design: {},
      email: '',
      errors: [],
    }
  },
  props: {
    breadcrumb: {type: Boolean, default: true},
    fullscreen: {type: Boolean, default: false},
    title: {type: String, default: "Draft Message"},
    id: String
  },
  mounted() {
    if (this.fullscreen) this.$root.$emit("hide_modal");
  },
  methods: {
    editorLoaded() {
      // Pass the template JSON here
      GraphQl.sendRequest('{broadcast(id:"' + this.id + '"){email_design}}')
          .then(response => {
            this.$refs.emailEditor.editor.loadDesign(JSON.parse(unescape(response.broadcast.email_design)));
          })
    },
    exportHtml() {
      this.$refs.emailEditor.editor.exportHtml(
          (data) => {
            this.design = data.design;
            this.email = data.html;
            this.saveRecord()
          }
      )
    },

    saveRecord() {
      let query = {
        mutation: "updateBroadcastEmail",
        input: {
          email: escape(this.email),
          design: escape(JSON.stringify(this.design)),
          id: this.id
        },
        output: "{code message recordId}"
      };

      console.log(query)

      GraphQl.sendRequest(query)
          .then(response => {
            this.$root.$emit(response.updateBroadcastEmail.code === 200 ? 'alert_success' : 'alert_error', [response.updateBroadcastEmail.message]);
          })
    }
  }
}
</script>

<style>
iframe {
  min-height: 1000px !important;
}
</style>